import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import TreeViewer from 'global/components/viewers/TreeViewer';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useContext, useEffect, useMemo, useState } from 'react';

export const _gamificationTypes = {
  appUser: 'appUser',
  item: 'item'
}

export const UiConnections = ({ handleCancel }) => {

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appNetworking } = aps_global ?? {}
  const { allowNetworking } = appNetworking ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}
  const { appUserCollection } = aps_appUserSettings ?? {}

  const appDataDocument = appDataDocuments?.[appUserCollection]

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { isMobileDevice: _isMobileDevice } = framework_state ?? {}

  const [connectionData, setConnectionData] = useState({})

  useEffect(() => {
    const cb1 = (data) => {
      if (data?.[appUserCollection]) {
        const aucs = {}
        const aucc = data[appUserCollection]
        if (aucc) {
          _.forEach(aucc, (auc, aucKey) => {
            if (appDataDocument?.[aucKey]) {
              aucs[aucKey] = appDataDocument[aucKey]
            }
          })
        }
        setConnectionData(aucs)
      }
    }
    const _refPath1 = createRefPath_event(pathViews, ['_appUserConnections', appUserSessionKey])
    database_fns.get_doc({ refPath: _refPath1, callback: cb1, opts: { returnFirstObject: true, ignoreId: true } })
  }, []);

  const _topperCaption = useMemo(() => {
    return 'Connections';
  }, [])

  const content = () => {
    return <TreeViewer data={connectionData} scNames={true} subNames={true} />
  }

  const wrapper = () => <Wrapper
    content={content()}
    wrapperType={wrapperTypes.padded}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={wrapper()}
    handleCancel={handleCancel}
    topperCaption={_topperCaption}
    wrapperCss={{ container: 'app-dark-mode' }}
  />

  return fullPageWrapper()
}
